export default {"src":"/_next/static/media/rabby.dc3732c5.svg","height":512,"width":512};